// Un `{marcador}`: minúscula al principio, 2 a 31 caracteres, sin espacios, dos puntos ni comillas
// (así los ejemplos JSON de los prompts oficiales no matchean). Es la MISMA regex con la que el
// Backend declara `unresolved_placeholders` a la IA (contrato §2.2): lo que el editor señala es lo
// que la IA va a recibir sin completar.
//
// Las llaves se capturan enteras para descartar las dobles (`{{client_name}}` es la convención de la
// matriz de prompts, no de la biblioteca) sin depender de un lookbehind.
const PLACEHOLDER_RE = /(\{+)([a-záéíóúñü][a-záéíóúñü0-9_]{1,30})(\}+)/g;

export const PLACEHOLDER_CLIENT = 'client';
export const PLACEHOLDER_PERIOD = 'period';
export const PLACEHOLDER_UNKNOWN = 'unknown';

/** Los marcadores del texto, sin duplicados y en orden de aparición. */
export function detectPlaceholders(text) {
    const found = [];
    const seen = new Set();
    for (const match of String(text || '').matchAll(PLACEHOLDER_RE)) {
        if (match[1].length !== 1 || match[3].length !== 1) continue;
        const token = match[2];
        if (seen.has(token)) continue;
        seen.add(token);
        found.push(token);
    }
    return found;
}

/**
 * Qué hace Dashbo con cada marcador: `{cliente}` lo completa el Backend con el cliente del prompt (o
 * el que nombra quien lo pide); `{período}` lo completa la IA según lo que se le pida; cualquier
 * otro viaja tal cual.
 */
export function placeholderKind(token) {
    if (token === 'cliente') return PLACEHOLDER_CLIENT;
    if (token === 'período' || token === 'periodo') return PLACEHOLDER_PERIOD;
    return PLACEHOLDER_UNKNOWN;
}

/**
 * Las notas que el editor muestra debajo del texto. `tipClient`: un prompt para todos los clientes
 * que no usa `{cliente}` probablemente tenga el nombre de un cliente escrito a mano.
 */
export function placeholderNotes(text, isAllClients) {
    const notes = detectPlaceholders(text).map((token) => ({token, kind: placeholderKind(token)}));
    const hasClient = notes.some((note) => note.kind === PLACEHOLDER_CLIENT);
    return {
        notes,
        tipClient: Boolean(isAllClients && String(text || '').trim() && !hasClient),
    };
}
